<template>
  <v-snackbar v-model="show">
    {{ message }}
    <v-btn color="pink" text @click="show = false">Close</v-btn>
  </v-snackbar>
</template>

<script>
import * as snackTypes from '../store/modules/utils/snackbar/types';

export default {
  name: 'Snackbar',
  data() {
    return {
      show: false,
      message: '',
    };
  },
  created() {
    this.$store.watch(
      state => state.snackBar.snack,
      () => {
        const msg = this.$store.state.snackBar.snack;
        if (msg !== '') {
          this.show = true;
          this.message = this.$store.state.snackBar.snack;
          this.$store.commit(`snackBar/${snackTypes.MUTATE_SNACKBAR}`, '');
        }
      },
    );
  },
};
</script>
